// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3RNfE","left":"InfoRow_left__30H9X"};